module.exports = __webpack_public_path__ + "img/social-icon.cf8ed30f.svg";